import { useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import { Group } from 'three';

const useMatrixUpdateHandler = (
  getShouldUpdate: () => boolean,
  group?: Group | null
) => {
  const initializedRef = useRef<boolean>(false);

  useFrame(() => {
    if (!group) return;

    if (!initializedRef.current) {
      group.matrixAutoUpdate = false;
      group.traverse(node => {
        node.matrixAutoUpdate = false;
      });
      initializedRef.current = true;
    }

    if (getShouldUpdate()) {
      group.updateMatrix();
      group.traverse(node => {
        node.updateMatrix();
      });
    }
  });
};

export default useMatrixUpdateHandler;
